import {
  lucideCalendarDays,
  lucideCircleArrowUp,
  lucideDatabase,
  lucideGift,
  lucideHouse,
  lucideKeyRound,
  lucideMail,
  lucideReceipt,
  lucideSettings,
  lucideTag,
  lucideTicket,
  lucideUsers,
  lucideWallet,
} from '@ng-icons/lucide';
import { Client } from '../events/models/client.model';

export const NAVIGATION_ICONS = {
  lucideCalendarDays,
  lucideCircleArrowUp,
  lucideDatabase,
  lucideGift,
  lucideHouse,
  lucideKeyRound,
  lucideMail,
  lucideReceipt,
  lucideSettings,
  lucideTag,
  lucideTicket,
  lucideUsers,
  lucideWallet,
};

export interface NavigationContext {
  client: Client | undefined;
}

export interface NavigationItem {
  path: string;
  label: string;
  title: string;
  icon: keyof typeof NAVIGATION_ICONS;
  dataCy: string;
  queryParams?: Record<string, string>;
  isVisible?: (context: NavigationContext) => boolean;
}

const FIRST_PAGE = { page: '1' };

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    title: 'Dashboard',
    icon: 'lucideHouse',
    dataCy: 'dashboard-sidebar-link',
  },
  {
    path: 'transactions',
    label: 'Transaction Management',
    title: 'Transactions management',
    icon: 'lucideWallet',
    dataCy: 'transactions-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'events',
    label: 'Events Management',
    title: 'Events management',
    icon: 'lucideCalendarDays',
    dataCy: 'events-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'upgrade',
    label: 'Upgrade Management',
    title: 'Upgrade management',
    icon: 'lucideCircleArrowUp',
    dataCy: 'upgrades-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'upsell',
    label: 'Upsell Management',
    title: 'Upsell management',
    icon: 'lucideGift',
    dataCy: 'upsells-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'discounts',
    label: 'Discounts Management',
    title: 'Discounts management',
    icon: 'lucideTicket',
    dataCy: 'discounts-sidebar-link',
    queryParams: FIRST_PAGE,
    isVisible: ({ client }) => !!client?.isDiscountCodesEnabled,
  },
  {
    path: 'adlink',
    label: 'AdLink Management',
    title: 'Adlink management',
    icon: 'lucideTag',
    dataCy: 'adlink-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'general-settings',
    label: 'General Settings',
    title: 'General Settings',
    icon: 'lucideSettings',
    dataCy: 'general-settings-sidebar-link',
  },
  {
    path: 'emails',
    label: 'Emails',
    title: 'Emails',
    icon: 'lucideMail',
    dataCy: 'emails-sidebar-link',
  },
  {
    path: 'service-charges',
    label: 'Fees Management',
    title: 'Fees management',
    icon: 'lucideReceipt',
    dataCy: 'fees-sidebar-link',
    isVisible: ({ client }) => !client?.isFeeFromPv,
  },
  {
    path: 'private-selling',
    label: 'Private Selling',
    title: 'Private Selling',
    icon: 'lucideKeyRound',
    dataCy: 'private-selling-sidebar-link',
    isVisible: ({ client }) => !!client?.isGroupLinkEnabled,
  },
];

export const ADMIN_TOOLS_ITEMS: NavigationItem[] = [
  {
    path: 'users',
    label: 'Users Management',
    title: 'Users management',
    icon: 'lucideUsers',
    dataCy: 'users-sidebar-link',
    queryParams: FIRST_PAGE,
  },
  {
    path: 'redis-manager',
    label: 'Redis Manager',
    title: 'Redis Manager',
    icon: 'lucideDatabase',
    dataCy: 'redis-sidebar-link',
    queryParams: FIRST_PAGE,
  },
];
